// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { ProviderServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Provider';
import { ERR_ACC_PROVIDER_SVC, SUC_ACC_PROVIDER_SVC } from '../../../../utils/strings';

export const useAcceptProviderServiceRequest = () => {
  const { submit } = useExerciseSubmission(
    ProviderServiceRequest.ProviderServiceRequest_Accept,
    SUC_ACC_PROVIDER_SVC,
    ERR_ACC_PROVIDER_SVC,
  );
  return submit;
};
